import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

// Section title
export const GroupLabel = styled("label")(({ theme }) => ({
  fontSize: "16px",
  fontWeight: "500",
  lineHeight: "24px",
  padding: "0 !important",
  color: "var(--Color-Text-Primary-On-Light, #1F1F1F)"
}));

// Container for form elements
export const FlexContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: "16px",
  position: "relative"
}));

// Flex item that takes full width by default
export const FlexItem = styled(Box)(({ theme }) => ({
  flex: "1 1 0"
}));

// Flex item for action buttons
export const FlexActionItem = styled(Box)(({ theme }) => ({
  flex: "0 0 auto",
  display: "flex",
  alignItems: "center",
  paddingTop: "8px"
}));

// Divider line between sections
export const Divider = styled(Box)(({ theme }) => ({
  marginTop: "30px",
  borderBottom: "solid 1px rgba(230, 230, 230, 0.5)"
}));

// Wrapper for controls
export const ControlsWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  margin: "20px 0 0"
}));

// Relative positioning container
export const RelativeBox = styled(Box)(({ theme }) => ({
  position: "relative"
}));

// Button wrapper
export const ButtonWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  margin: "40px 0"
}));

// Info titles
export const InfoTitles = styled(Box)(({ theme }) => ({
  marginBottom: "10px"
}));

// Remove button styling
export const RemoveButtonWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  right: 0,
  top: 0
}));
